export default "__VITE_ASSET__2cd014fb__"